import Vue from 'vue';
import Vuex from 'vuex';
import config from '@/store/config.store';
import componentIDs from '@/store/component-ids.store';
import idMixin from '@/mixins/component-ids';
import router from '../router';

Vue.use(Vuex);

const dateFormat = require('dateformat');

const now = new Date();

export default new Vuex.Store({
	state: {
		level: 0,
		scene: 0, // each time a person requests a loan, even special and returns, scene will increment
		totalLevels: null, // total number of levels in the game
		gameArray: [],
		totalMoney: 0, // player's total money earned
		scores: [], // all player's scores in an array
		score: 0, // player's average score (1-3), 1 is best
		playerName: null,
		adjective: null,
		deskItem: null,
		deskItem2: null,
		deskItem3: null,
		infoOpen: false,
		todaysDate: dateFormat(now, "dddd, mmmm dS, yyyy"),
		returnerAnswers: [],
		paydayPerson: null,
		paydayFees: 0,
	},
	actions: {
	},
	mutations: {
		updateTotalMoney(state, payload) {
			state.totalMoney += payload;
		},
		updateScore(state, payload) { // score is average of all answers
			state.scores.push(payload); // 1-3 with 1 being most correct, 3 being most incorrect
			const length = state.scores.length;
			let sum = 0;
			for (let i = 0; i < length; i += 1) {
				sum += state.scores[i];
			}
			state.score = sum / length;
		},
		updatePaydayFees(state, payload) {
			state.paydayFees += payload;
		},
		setPlayerName(state, payload) {
			state.playerName = payload;
		},
		setPaydayPerson(state, payload) {
			state.paydayPerson = payload;
		},
		setTotalLevels(state, payload) {
			state.totalLevels = payload;
		},
		buildGameArray(state, payload) {
			state.gameArray.push(payload);
		},
		incrementScene(state) {
			state.scene += 1;
			if (state.scene >= state.gameArray[state.level].length) {
				state.level += 1;
				state.scene = 0;
				if (state.level < state.totalLevels) { // if at end of level
					// go to reward email
					router.push({ name: 'Reward', params: { level: state.level } });
				} else {
					// go to end of game
					router.push({ name: 'GameOverEmail' });
				}
			} else {
				// go to next scene
				router.push({ name: 'Scene', params: { level: state.level, scene: state.scene } });
			}
		},
		setDeskItem(state, payload) {
			if (state.level === 1) {
				state.deskItem = payload;
			} else if (state.level === 2) {
				state.deskItem2 = payload;
			} else if (state.level === 3) {
				state.deskItem3 = payload;
			}
		},
		setAdjective(state, payload) {
			state.adjective = payload;
		},
		toggleInfoOpen(state, payload) {
			state.infoOpen = payload;
		},
		addReturnerAnswer(state, payload) {
			state.returnerAnswers.push(payload);
		},
		resetGame(state) {
			state.level = 0;
			state.scene = 0;
			state.totalLevels = null;
			state.gameArray = [];
			state.totalMoney = 0;
			state.scores = [];
			state.score = 0;
			state.playerName = null;
			state.adjective = null;
			state.deskItem = null;
			state.deskItem2 = null;
			state.deskItem3 = null;
			state.infoOpen = false;
			state.todaysDate = dateFormat(now, "dddd, mmmm dS, yyyy");
			state.returnerAnswers = [];
			state.paydayPerson = null;
			state.paydayFees = 0;
		},
	},
	getters: {
		//
		getRequestsByType: state => type => state.config.data.request.filter(request => request.request_type === type),
		//
		getRequestsByTypeAndLevel: state => (level, type) => state.config.data.request.filter(request => request.game_level === level && request.request_type === type),
		//
		getRequestsByTypeAndLevelAndOrder: state => (level, type, order) => state.config.data.request.filter(request => request.game_level === level && request.request_type === type && request.request_order === order),
		//
		getEmailByTypeAndLevel: state => (level, type) => state.config.data.email.find(email => email.progress_report_level === level && email.email_type === type),
		//
		getEmailByID: state => id => state.config.data.email.find(email => email.id === id),
		//
		getPersonByID: state => id => state.config.data.person.find(person => person.id === id),
		//
		getPeopleForRandoms: state => bool => state.config.data.person.filter(person => person.is_a_special === bool),
		//
		getReturnerPrevAnswer: state => id => state.returnerAnswers.find(returnerAnswers => returnerAnswers.id === id),
		//
		getAdjectivesByPerformance: state => perf => state.config.data.nickname.find(nickname => nickname.title === perf),
	},
	modules: {
		config,
		componentIDs,
	},
});

Vue.mixin(idMixin);



// WEBPACK FOOTER //
// ./src/store/index.js